import { Box, SvgIcon, Typography, Button } from '@mui/material';
import PageArea from './../../../components/shared/PageArea';
import PageTitle from './../../../components/shared/PageTitle';
import { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { theme } from './../../../theme';
import ReportDialog from '../components/shared/ReportDialog';
import { ReportNavItem, AIOrderingReports } from '../components/shared/ReportTypesData';
import { UserContext } from '../../../components/shared/useUser';
import AIOrderingWidgets from './components/AIOrderingWidgets';

const AIReporting = () => {
  const { t } = useTranslation('common');
  const [open, setOpen] = useState(false);
  const [selectedReport, setSelectedReport] = useState<ReportNavItem>(AIOrderingReports[0]);
  const { selectedStore } = useContext(UserContext);

  const handleClose = () => {
    setOpen(false);
  };

  const handleGenerateClick = (reportType: string) => {
    const item = AIOrderingReports.find(x => x.title === reportType);

    if (!item) return;

    setSelectedReport(item);
    setOpen(true);
  };

  return (
    <PageArea>
      <Box
        display='flex'
        flexDirection='column'
        flex={1}
        alignItems='start'
      >
        <PageTitle>{t('reporting.ai-reporting-title')}</PageTitle>
        <Typography variant="displayMD"
          sx={{ fontSize: '16px', display:'block' }}
          gutterBottom>{selectedStore?.storeName}</Typography>
      </Box>
      <Box sx={ {
        py: '12px',
        color: theme.palette.common.black,
        fontWeight: 'bold',
      }}>
      </Box>
      <Box sx={{
        display: 'flex', flexDirection: 'column', width: '100%', height: '100%', p: '12px', border: `solid 1px ${theme.palette.common.white}`,
        borderRadius: '4px',
      }}>
        {
          AIOrderingReports.map((item) => {
            return (
              <Box key={item.title}
                sx={{
                  display: 'flex',
                  width: '100%',
                  minHeight: '60px',
                  p: '12px',
                  alignItems: 'center',
                  justifyContent: 'left',
                  mb: '12px',
                  border: `solid 1px ${theme.palette.custom.gray[200]}`,
                  borderRadius: '4px',
                }}>
                <SvgIcon sx={{ width: '20px', mr: '24px' }}>{item.icon}</SvgIcon>
                <Typography variant="textMD"
                  sx={{ display: 'flex', flex: 1, justifyContent: 'left' }}>{t(item.title)}</Typography>
                <Button size='lg'
                  onClick={() => handleGenerateClick(item.title)}>{t('reporting.generate')}</Button>
              </Box>
            );
          })
        }
        <AIOrderingWidgets></AIOrderingWidgets>
      </Box>
      <ReportDialog
        open={open}
        onClose={handleClose}
        reportItem={selectedReport}
      />
    </PageArea>
  );
};

export default AIReporting;